<template>
  <el-dialog
      :title="setId?'编辑服务类目':'新增服务类目'"
      :visible.sync="serverDialog"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false"
      width="600px"
      center>
    <el-form :model="serverForm" :rules="rules" ref="serverForm" label-width="100px">
      <el-form-item label="服务内容" prop="content">
        <el-input type="textarea" v-model="serverForm.content" placeholder="请输入服务内容"></el-input>
      </el-form-item>
      <el-form-item label="消耗积分" prop="score">
        <el-input type="number" v-model.number="serverForm.score" placeholder="请输入消耗积分"></el-input>
      </el-form-item>
      <el-form-item class="flex align-center justify-around" label-width="0">
        <el-button class="padding-lr-xl" @click="resetForm('serverForm')">取消</el-button>
        <el-button class="padding-lr-xl" type="primary" @click="submitForm('serverForm')">提交</el-button>
      </el-form-item>
    </el-form>
  </el-dialog>
</template>

<script>
import {addProjectService} from "@/api/weilao";
export default {
  name: "serverContentDialog",
  props: {
    serverDialog: {
      type: Boolean,
      default: false
    },
    setId: {
      type: Number,
      default() {
        return 0;
      }
    },
    activeIndex: {
      type: Number,
      default() {
        return 0;
      }
    },
    setItem: {
      type: Object
    }
  },
  data() {

    return {
      serverForm: {
        content: '',
        score: '',
      },
      rules: {
        content: [{required: true, message: '请输入服务内容', trigger: 'blur'}],
        score: [{required: true, message: '请输入消耗积分', trigger: 'blur'}],
      }
    }
  },
  computed:{
    user() {
      return this.$store.state.user
    },
  },
  methods:{
    resetForm(formName){
      this.$refs[formName].resetFields();
      this.$emit('cancelDialog',false)
    },
    submitForm(formName){
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.submitData(formName)
        }
      });
    },
    async submitData(formName) {
      let _state = await addProjectService(
          this.activeIndex+1,
          this.serverForm.content,
          this.serverForm.score,
          this.setId?this.setId:'',
      );
      this.$message.success(_state.info);
      this.$refs[formName].resetFields();
      this.$emit("cancelDialog", true);
    }
  },
  watch: {
    setItem() {
      this.serverForm = {
        content: this.setItem.content,
        score: this.setItem.score,
      };
    }
  }
}
</script>

<style scoped lang="scss">

</style>
